import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { Location } from '@gatsbyjs/reach-router';
import React, { useState } from 'react';

import Icon from '@components/Icon/Icon';
import ToolTip from '@components/Tooltip/index';

import { getLocationNameArray } from '@utils/url';

import { ButtonImage, ButtonImageContainer } from './SideButton.style';

const SideButton = React.forwardRef<
  HTMLButtonElement,
  {
    route?: string;
    iconName: IconName;
    iconNameHover?: IconName;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    bottom?: boolean;
    hoverText?: string;
    iconRotation?: number;
    showTooltip?: boolean;
    iconType?: IconPrefix;
    color?: string;
  }
>(
  (
    {
      route = '',
      iconName,
      onClick,
      bottom = false,
      hoverText = '',
      iconRotation = 0,
      iconNameHover,
      showTooltip = true,
      iconType = undefined,
      color = 'primary.contrastText',
    },
    ref
  ) => {
    const [hovering, setHovering] = useState(false);

    return (
      <Location>
        {({ location }) => {
          const locationNames = getLocationNameArray(location);
          const active = locationNames.includes(route.split('/')[1]);
          return (
            <ButtonImageContainer
              bottom={bottom}
              onBlur={() => setHovering(false)}
              onClick={onClick}
              onFocus={() => setHovering(true)}
              onMouseOut={() => setHovering(false)}
              onMouseOver={() => setHovering(true)}
              ref={ref}
              type="button"
            >
              <ButtonImage bottom={bottom} highlighted={active}>
                <Icon
                  clickable
                  color={color}
                  name={
                    hovering || active ? (iconNameHover ?? iconName) : iconName
                  }
                  opacity={hovering || active ? 1 : 0.66}
                  rotation={iconRotation}
                  type={iconType ?? (hovering || active ? 'fas' : 'fat')}
                />
              </ButtonImage>
              {showTooltip ? (
                <ToolTip display={hovering}>{hoverText}</ToolTip>
              ) : null}
            </ButtonImageContainer>
          );
        }}
      </Location>
    );
  }
);

export default SideButton;
